const tagColorsMixin = {
  methods: {
    _getTagStyle() {
      const colorIdx = this.curColor % this.extTagColorList.length;
      this.curColor += 1;
      return this.extTagColorList[colorIdx].style;
    },
    getTagStyle(styleName) {
      //const found = colorList.find(item => item.name === styleName)
      const found = this.extTagColorList.find(item => item.name === styleName);
      if (found) {
        return found.style;
      } else {
        return {};
      }
    },
  },
  data() {
    return {
      //@tmp
      curColor: 0,
      tagColorList: [
        { value: "primary", txtLabel: "藍", txtColor: "#409EFF" },
        { value: "success", txtLabel: "綠", txtColor: "#67C23A" },
        { value: "warning", txtLabel: "橙", txtColor: "#E6A23C" },
        { value: "danger", txtLabel: "紅", txtColor: "#F56C6C" },
        { value: "info", txtLabel: "灰", txtColor: "#909399" },
      ],
      extTagColorList: [
        {
          name: "primary",
          txtLabel: "藍　",
          style: {
            backgroundColor: "#ecf5ff",
            borderColor: "#d9ecff",
            color: "#409EFF",
          },
          textColor: "#409EFF",
        },
        {
          name: "success",
          txtLabel: "綠　",
          style: {
            backgroundColor: "#f0f9eb",
            borderColor: "#e1f3d8",
            color: "#67c23a",
          },
          textColor: "#67c23a",
        },
        {
          name: "warning",
          txtLabel: "橙　",
          style: {
            backgroundColor: "#fdf6ec",
            borderColor: "#faecd8",
            color: "#e6a23c",
          },
          textColor: "#e6a23c",
        },
        {
          name: "danger",
          txtLabel: "紅　",
          style: {
            backgroundColor: "#fef0f0",
            borderColor: "#fde2e2",
            color: "#f56c6c",
          },
          textColor: "#f56c6c",
        },
        {
          name: "info",
          txtLabel: "灰　",
          style: {
            backgroundColor: "#f4f4f5",
            borderColor: "#e9e9eb",
            color: "#909399",
          },
          textColor: "#909399",
        },
        {
          name: "darkBlue",
          txtLabel: "深藍",
          style: {
            backgroundColor: "#2354A0",
            borderColor: "#2354A0",
            color: "#ffffff",
          },
          textColor: "#2354A0",
        },
        {
          name: "darkGreen",
          txtLabel: "深綠",
          style: {
            backgroundColor: "#62974F",
            borderColor: "#62974F",
            color: "#ffffff",
          },
          textColor: "#62974F",
        },
        {
          name: "darkOrange",
          txtLabel: "深橙",
          style: {
            backgroundColor: "#e66819",
            //backgroundColor: "#BE632C",
            borderColor: "#BE632C",
            color: "#ffffff",
          },
          textColor: "#e66819",
        },
        {
          name: "darkRed",
          txtLabel: "深紅",
          style: {
            backgroundColor: "#BF3D30",
            borderColor: "#BF3D30",
            color: "#ffffff",
          },
          textColor: "#BF3D30",
        },
        {
          name: "darkGray",
          txtLabel: "深灰",
          style: {
            backgroundColor: "#8B8B8B",
            borderColor: "#8B8B8B",
            color: "#ffffff",
          },
          textColor: "#8B8B8B",
        },
        //{
        //name: "purple",
        //txtLabel: "紫",
        //style: {
        ////color: "#ffffff",
        ////backgroundColor: "#73367C",
        //color: "#73367C",
        //backgroundColor: "#f6edf7",
        //borderColor: "#e4cae8",
        ////color: "#ff33ff",
        ////backgroundColor: "#ffe6ff",
        ////borderColor: "#ffccff",
        //},
        //},
      ],
    };
  },
};

export default tagColorsMixin;
